import { ConversionType, SaleStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { ProductConversionModel } from "@gtpl/shared-models/procurement-management";
import { BaseEntity, Column, CreateDateColumn, Entity, Index, JoinColumn, OneToMany, OneToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("product_conversion_log")

export class ProductConversion {

    @PrimaryGeneratedColumn("increment", { name: 'product_conversion_id' })
    productConversionId: number;

    @Column("int", {
        nullable: false,
        name: "from_sale_order_id"
    })
    fromSaleOrderId: number;

    @Column("int", {
        nullable: false,
        name: "from_so_item_id"
    })
    fromSaleOrderItemId: number;


    @Column("int", {
        nullable: true,
        name: "from_quantity",
    })
    fromQuantity: number;

    @Column("int", {
        nullable: false,
        name: "to_sale_order_id"
    })
    toSaleOrderId: number;

    @Column("int", {
        nullable: false,
        name: "to_so_item_id"
    })
    toSaleOrderItemId: number;


    @Column("int", {
        nullable: false,
        name: "conversion_qty",
    })
    conversionQty: number;

    @Column("int", {
        nullable: false,
        name: "location_id",
    })
    locationId: number;

    @Column("int", {
        nullable: false,
        name: "unit_id",
    })
    unitId: number;


    @Column("enum", {
        nullable: false,
        name: "conversion_type",
        enum: ConversionType,
    })
    conversionType: ConversionType;

    @Column("varchar", {
        nullable: true,
        name: "reason",
    })
    reason: string

    @Column("varchar", {
        nullable: true,
        name: "remarks",
    })
    remarks: string

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;


    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;

}

